import Clawed_01 from "../hands/Clawed_01_small.png";
import Clawed_02 from "../hands/Clawed_02_small.png";
import Clawed_03 from "../hands/Clawed_03_small.png";
import Clawed_04 from "../hands/Clawed_04_small.png";
import Clawed_05 from "../hands/Clawed_05_small.png";
import Duck_01 from "../hands/Duck_01_small.png";
import Duck_02 from "../hands/Duck_02_small.png";
import Duck_03 from "../hands/Duck_03_small.png";
import Duck_04 from "../hands/Duck_04_small.png";
import Duck_05 from "../hands/Duck_05_small.png";
import Duck_06 from "../hands/Duck_06_small.png";
import Fist_01 from "../hands/Fist_01_small.png";
import Fist_02 from "../hands/Fist_02_small.png";
import Fist_03 from "../hands/Fist_03_small.png";
import Fist_04 from "../hands/Fist_04_small.png";
import Fist_05 from "../hands/Fist_05_small.png";
import Grabbed_01 from "../hands/Grabbed_01_small.png";
import Grabbed_02 from "../hands/Grabbed_02_small.png";
import Grabbed_03 from "../hands/Grabbed_03_small.png";
import Grabbed_04 from "../hands/Grabbed_04_small.png";
import Grasping_01 from "../hands/Grasping_01_small.png";
import Grasping_02 from "../hands/Grasping_02_small.png";
import Grasping_03 from "../hands/Grasping_03_small.png";
import Grasping_04 from "../hands/Grasping_04_small.png";
import Grasping_05 from "../hands/Grasping_05_small.png";
import Grasping_06 from "../hands/Grasping_06_small.png";
import Grasping_07 from "../hands/Grasping_07_small.png";
import Grasping_08 from "../hands/Grasping_08_small.png";
import Grasping_09 from "../hands/Grasping_09_small.png";
import Pinch_01 from "../hands/Pinch_01_small.png";
import Pinch_02 from "../hands/Pinch_02_small.png";
import Pinch_03 from "../hands/Pinch_03_small.png";
import Pinch_04 from "../hands/Pinch_04_small.png";
import Pinch_05 from "../hands/Pinch_05_small.png";
import Pinch_06 from "../hands/Pinch_06_small.png";
import PinchZoom_01 from "../hands/PinchZoom_01_small.png";
import PinchZoom_02 from "../hands/PinchZoom_02_small.png";
import PinchZoom_03 from "../hands/PinchZoom_03_small.png";
import PinchZoom_04 from "../hands/PinchZoom_04_small.png";
import PinchZoom_05 from "../hands/PinchZoom_05_small.png";
import PinkieTwist_01 from "../hands/PinkieTwist_01_small.png";
import PinkieTwist_02 from "../hands/PinkieTwist_02_small.png";
import PinkieTwist_03 from "../hands/PinkieTwist_03_small.png";
import PinkieTwist_04 from "../hands/PinkieTwist_04_small.png";
import PinkieTwist_05 from "../hands/PinkieTwist_05_small.png";
import PinkieTwist_06 from "../hands/PinkieTwist_06_small.png";
import Pointing_01 from "../hands/Pointing_01_small.png";
import Pointing_02 from "../hands/Pointing_02_small.png";
import Pointing_03 from "../hands/Pointing_03_small.png";
import Pointing_04 from "../hands/Pointing_04_small.png";
import Pointing_05 from "../hands/Pointing_05_small.png";
import Relaxed_01 from "../hands/Relaxed_01_small.png";
import Relaxed_02 from "../hands/Relaxed_02_small.png";
import Relaxed_03 from "../hands/Relaxed_03_small.png";
import Relaxed_04 from "../hands/Relaxed_04_small.png";
import Relaxed_05 from "../hands/Relaxed_05_small.png";
import Relaxed_06 from "../hands/Relaxed_06_small.png";
import Relaxed_07 from "../hands/Relaxed_07_small.png";
import Snapping_01 from "../hands/Snapping_01_small.png";
import Snapping_02 from "../hands/Snapping_02_small.png";
import Snapping_03 from "../hands/Snapping_03_small.png";
import Snapping_04 from "../hands/Snapping_04_small.png";
import Special_01 from "../hands/Special_01_small.png";
import Special_02 from "../hands/Special_02_small.png";
import Special_03 from "../hands/Special_03_small.png";
import Special_04 from "../hands/Special_04_small.png";
import Special_05 from "../hands/Special_05_small.png";
import Special_06 from "../hands/Special_06_small.png";
import Special_07 from "../hands/Special_07_small.png";
import Special_08 from "../hands/Special_08_small.png";
import Special_09 from "../hands/Special_09_small.png";
import Special_10 from "../hands/Special_10_small.png";
import Special_11 from "../hands/Special_11_small.png";
import Special_12 from "../hands/Special_12_small.png";
import Splayed_01 from "../hands/Splayed_01_small.png";
import Splayed_02 from "../hands/Splayed_02_small.png";
import Splayed_03 from "../hands/Splayed_03_small.png";
import Splayed_04 from "../hands/Splayed_04_small.png";
import Splayed_05 from "../hands/Splayed_05_small.png";
import ThumbsUp_01 from "../hands/ThumbsUp_01_small.png";
import ThumbsUp_02 from "../hands/ThumbsUp_02_small.png";
import ThumbsUp_03 from "../hands/ThumbsUp_03_small.png";
import ThumbsUp_04 from "../hands/ThumbsUp_04_small.png";

const hands = {
  name: "Hands",
  isImagePrompt: true,
  isRotatable: true,
  prompts: [
    Clawed_01,
    Clawed_02,
    Clawed_03,
    Clawed_04,
    Clawed_05,
    Duck_01,
    Duck_02,
    Duck_03,
    Duck_04,
    Duck_05,
    Duck_06,
    Fist_01,
    Fist_02,
    Fist_03,
    Fist_04,
    Fist_05,
    Grabbed_01,
    Grabbed_02,
    Grabbed_03,
    Grabbed_04,
    Grasping_01,
    Grasping_02,
    Grasping_03,
    Grasping_04,
    Grasping_05,
    Grasping_06,
    Grasping_07,
    Grasping_08,
    Grasping_09,
    Pinch_01,
    Pinch_02,
    Pinch_03,
    Pinch_04,
    Pinch_05,
    Pinch_06,
    PinchZoom_01,
    PinchZoom_02,
    PinchZoom_03,
    PinchZoom_04,
    PinchZoom_05,
    PinkieTwist_01,
    PinkieTwist_02,
    PinkieTwist_03,
    PinkieTwist_04,
    PinkieTwist_05,
    PinkieTwist_06,
    Pointing_01,
    Pointing_02,
    Pointing_03,
    Pointing_04,
    Pointing_05,
    Relaxed_01,
    Relaxed_02,
    Relaxed_03,
    Relaxed_04,
    Relaxed_05,
    Relaxed_06,
    Relaxed_07,
    Snapping_01,
    Snapping_02,
    Snapping_03,
    Snapping_04,
    Special_01,
    Special_02,
    Special_03,
    Special_04,
    Special_05,
    Special_06,
    Special_07,
    Special_08,
    Special_09,
    Special_10,
    Special_11,
    Special_12,
    Splayed_01,
    Splayed_02,
    Splayed_03,
    Splayed_04,
    Splayed_05,
    ThumbsUp_01,
    ThumbsUp_02,
    ThumbsUp_03,
    ThumbsUp_04,
  ],
};

export default hands;
